export default "__VITE_ASSET__32c750ce__"